import { TNbPlayers } from "../Models/TNbPlayers";

export interface IState {
    player: {
        level: number;
        currentHp: number;
        hpMax: number;
        characterInfo: {
            name: string;
            species: string;
            archetype: string;
        };
    },
    master: {
        episodeNumber: number;
        sceneNumber: number;
        numberOfPlayers: TNbPlayers;
        isPlaying: boolean;
        playlistId: string;
        creaturesOnBoard: { id: string, currentHp: number }[];
    }
}

const initialState: IState = {
    player: {
        level: -1,
        currentHp: -1,
        hpMax: -1,
        characterInfo: {
            name: "",
            species: "",
            archetype: ""
        }
    },
    master: {
        episodeNumber: -1,
        sceneNumber: 1,
        numberOfPlayers: 2,
        isPlaying: false,
        playlistId: "",
        creaturesOnBoard: []
    }
};

export const actions = {
    player: {
        SET_LEVEL: 'SET_LEVEL',
        SET_CURRENT_HP: 'SET_CURRENT_HP',
        SET_CHARACTER_INFO: 'SET_CHARACTER_INFO',
    },
    master: {
        SET_EPISODE_NUMBER: 'SET_EPISODE_NUMBER',
        SET_SCENE_NUMBER: 'SET_SCENE_NUMBER',
        SET_NUMBER_PLAYERS: 'SET_NUMBER_PLAYERS',
        SET_IS_PLAYING: 'SET_IS_PLAYING',
        SET_PLAYLIST_ID: 'SET_PLAYLIST_ID',
        SET_CREATURES: 'SET_CREATURES',
        SET_CREATURE_HP: 'SET_CREATURE_HP',
    }
}

interface ISetCreatureHpAction {
    index: number;
    hp: number;
}

export const reducer = (state = initialState, action: { type: string; payload: IState | ISetCreatureHpAction }) => {

    var payloadAction = action.payload as IState

    switch (action.type) {
        /* PLAYER */
        case actions.player.SET_LEVEL:
            return {
                ...state,
                player: {
                    ...state.player,
                    level: payloadAction.player.level,
                    hpMax: payloadAction.player.hpMax,
                    currentHp: payloadAction.player.currentHp
                }
            };
        case actions.player.SET_CURRENT_HP:
            return {
                ...state,
                player: {
                    ...state.player,
                    currentHp: payloadAction.player.currentHp,
                }
            };
        case actions.player.SET_CHARACTER_INFO:
            return {
                ...state,
                player: {
                    ...state.player,
                    characterInfo: payloadAction.player.characterInfo
                }
            };

        /* MASTER */
        case actions.master.SET_EPISODE_NUMBER:
            return {
                ...state,
                master: {
                    ...state.master,
                    episodeNumber: payloadAction.master.episodeNumber,
                    sceneNumber: 1,
                    creaturesOnBoard: [],
                }
            };
        case actions.master.SET_SCENE_NUMBER:
            return {
                ...state,
                master: {
                    ...state.master,
                    sceneNumber: payloadAction.master.sceneNumber
                }
            };
        case actions.master.SET_NUMBER_PLAYERS:
            return {
                ...state,
                master: {
                    ...state.master,
                    numberOfPlayers: payloadAction.master.numberOfPlayers
                }
            };
        case actions.master.SET_IS_PLAYING:
            return {
                ...state,
                master: {
                    ...state.master,
                    isPlaying: payloadAction.master.isPlaying
                }
            };
        case actions.master.SET_PLAYLIST_ID:
            return {
                ...state,
                master: {
                    ...state.master,
                    playlistId: payloadAction.master.playlistId,
                    isPlaying: true
                }
            };
        case actions.master.SET_CREATURES:
            return {
                ...state,
                master: {
                    ...state.master,
                    creaturesOnBoard: payloadAction.master.creaturesOnBoard
                }
            }
        case actions.master.SET_CREATURE_HP:
            let playloadAction = action.payload as ISetCreatureHpAction;
            let newArray = state.master.creaturesOnBoard.map((creature, index) =>
                index === playloadAction.index ? { id: creature.id, currentHp: playloadAction.hp } : creature);
            return {
                ...state,
                master: {
                    ...state.master,
                    creaturesOnBoard: newArray
                }
            }
        default:
            return state;
    }
};
